import { render, staticRenderFns } from "./GenericComponent.vue?vue&type=template&id=c7234d5a&"
import script from "./GenericComponent.vue?vue&type=script&lang=js&"
export * from "./GenericComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports